import {
  ActionIcon,
  Box,
  Group,
  Input,
  TextInput,
  Text,
  Tooltip,
  Button,
  Menu,
  FileInput,
  Stack,
  Popover,
} from "@mantine/core";
import React, { useState, useRef, useEffect } from "react";
import {
  IconMoodHappy,
  IconPhoto,
  IconCirclePlus,
  IconFolder,
} from "@tabler/icons";
import EmojiPicker from "emoji-picker-react";
import { useClickOutside, getHotkeyHandler } from "@mantine/hooks";
import { showNotification } from "@mantine/notifications";
// import { socket } from "../services/socket";
import dayjs from "dayjs";
import { date } from "zod";
import { User } from "../App";
import { Message, UserTypes } from "../pages/ChatGPT";
import { api, baseURL } from "../services/api";
import ThreeDots from "./animations/ThreeDots";

const MAX_IMAGE_FILE_SIZE = 5 * 1024 * 1024; //5M

interface Props {
  messages: Message[];
  setMessages: (
    messages: Message[] | ((messages: Message[]) => Message[])
  ) => void;
}

function ChatGptInput({ messages, setMessages }: Props) {
  const [isMultiPickerActive, setIsMultiPickerActive] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const textInputRef = useRef<HTMLInputElement>(null);
  //const albumInputRef = useRef(null);
  const multiPickerRef = useClickOutside(() => setIsMultiPickerActive(false));

  // const handleUpload = (e) => {
  //   const { files } = e.target;
  // };

  const handleSubmit = async () => {
    if (isSubmitting) return;
    let localMessage = "";
    // console.log(
    //   "textInputRef.current?.value",
    //   textInputRef.current?.value,
    //   textInputRef.current!.value
    // );

    if (textInputRef.current?.value) {
      localMessage = textInputRef.current?.value;
      const userTypeMessages = messages.flatMap((message) =>
        message.user.type === UserTypes.LOCAL
          ? { role: "user", content: message.content }
          : []
      );
      const formattedMessages = [
        ...userTypeMessages,
        { role: "user", content: localMessage },
      ];

      setMessages((prev) => [
        ...prev,
        {
          user: {
            name: "You",
            type: UserTypes.LOCAL,
          },
          content: localMessage,
          type: "text",
        },
      ]);
      textInputRef.current.value = "";

      try {
        setIsSubmitting(true);
        const response = await api.post("chatgpt", {
          message: localMessage,
          messages: formattedMessages,
        });
        // console.log("response", response);
        // const stream = response.data;

        // stream.on("data", (data: any) => {
        //   console.log(data);
        // });

        // const response = await fetch(baseURL + "chatgpt", {
        //   method: "POST",
        //   headers: {
        //     "Content-Type": "application/json",
        //   },
        //   body: JSON.stringify({ message }),
        // });
        // const reader = response.body
        //   ?.pipeThrough(new TextDecoderStream())
        //   .getReader();

        // while (true) {
        //   const { value, done } = await reader!.read();
        //   if (done) break;
        //   console.log("Received", value);
        // }

        setMessages((prev) => [
          ...prev,
          {
            user: {
              name: "ChatGPT",
              type: UserTypes.CHATGPT,
            },
            content: response.data.data.choices[0].message.content,
            type: "text",
          },
        ]);
      } catch (error: any) {
        console.log(error.response?.data?.message || error.message);
        showNotification({
          title: "错误",
          message: error.response?.data?.message || error.message,
          color: "red",
        });
      }
      setIsSubmitting(false);
    }
  };

  return (
    <Box
      py='5px'
      px='2px'
      sx={(theme) => ({
        backgroundColor: theme.colors.gray[0],
        position: "relative",
      })}
    >
      {isSubmitting && (
        <Box sx={{ position: "absolute", left: "4rem", bottom: "4rem" }}>
          <ThreeDots />
        </Box>
      )}

      <Group position='apart'>
        <TextInput
          ref={textInputRef}
          placeholder='输入消息...'
          sx={{ flex: "1" }}
          onKeyUp={getHotkeyHandler([["Enter", handleSubmit]])}
        />
        <Group>
          <Box>
            <Tooltip label='选择预设提问问题' position='top-end' withArrow>
              <ActionIcon
                onClick={() => setIsMultiPickerActive((prev) => !prev)}
              >
                <IconCirclePlus size={24} />
              </ActionIcon>
            </Tooltip>
          </Box>

          <Button
            variant='gradient'
            gradient={{ from: "teal", to: "green", deg: 60 }}
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            发送
          </Button>
        </Group>
      </Group>
      <Box sx={{ width: "100%" }}>
        {isMultiPickerActive && (
          <Box ref={multiPickerRef} m='1rem'>
            <Group position='center' spacing='xl'>
              <Popover
                width={200}
                position='bottom'
                withArrow
                shadow='md'
                radius='xl'
              >
                <Popover.Target>
                  <label style={{ textAlign: "center" }}>
                    <IconFolder size={34} style={{ opacity: 0.5 }} />
                    <Text size='sm'>文件</Text>
                    <input
                      // ref={albumInputRef}
                      disabled
                      type='file'
                      accept='image/*, video/*'
                      style={{ display: "none" }}
                      //onChange={handleUpload}
                    />
                  </label>
                </Popover.Target>
                <Popover.Dropdown
                  sx={(theme) => ({
                    backgroundColor: theme.colors.orange[3],
                  })}
                >
                  <Text size='sm'>该功能正在开发中，请稍后查看</Text>
                </Popover.Dropdown>
              </Popover>
            </Group>
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default ChatGptInput;
